export const authCheckboxLabelClassName = "auth-checkbox-label";

export const authCheckboxLabelStyle = {
  fontSize: 12,
  lineHeight: 19.2,
  color: "#06053499"
};

export const authCheckboxLabelTagsStyles = {
  p: {
    marginTop: 0,
    marginBottom: 0,
    ...authCheckboxLabelStyle
  },
  span: authCheckboxLabelStyle,
  a: {
    ...authCheckboxLabelStyle,
    textDecorationLine: "underline"
  }
};
